/* Newsletter-Fenster: Exit-Intent am Desktop, Zeitverzögerung am Handy.
   Nie auf Produkt-/Warenkorbseite automatisch, höchstens alle 30 Tage, nie nach Anmeldung. */
(() => {
  const KEY = 'gs-popup-seen';
  const DONE = 'gs-popup-done';
  const DAYS = 30;

  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* privat */ } }
  };

  class GsNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.querySelectorAll('[data-gs-popup-close]').forEach((b) =>
        b.addEventListener('click', () => this.close())
      );
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      this.dialog.addEventListener('close', () => this.remember());

      const copy = this.querySelector('[data-gs-popup-copy]');
      if (copy) copy.addEventListener('click', () => this.copyCode());

      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', () => store.set(DONE, '1'));

      /* Nach dem Absenden: Ergebnis sofort zeigen */
      const posted = window.location.hash === `#${this.dataset.formId}`;
      if (posted && this.querySelector('[data-gs-popup-result]')) {
        this.open(true);
        return;
      }

      if (store.get(DONE)) return;
      const seen = Number(store.get(KEY) || 0);
      if (seen && Date.now() - seen < DAYS * 864e5) return;
      if (this.dataset.template === 'product' || this.dataset.template === 'cart') return;

      const start = Date.now();
      const desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (desktop) {
        this.onLeave = (e) => {
          if (e.relatedTarget || e.clientY > 0) return;
          if (Date.now() - start < 8000) return;
          this.open();
        };
        document.addEventListener('mouseout', this.onLeave);
      } else {
        const delay = Math.max(15, Number(this.dataset.mobileDelay) || 40) * 1000;
        this.timer = window.setTimeout(() => {
          if (document.visibilityState === 'visible') this.open();
        }, delay);
      }
    }

    cookieBannerVisible() {
      const b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      const r = b.getBoundingClientRect();
      return r.height > 0 && getComputedStyle(b).display !== 'none' && getComputedStyle(b).visibility !== 'hidden';
    }

    open(force) {
      if (this.dialog.open) return;
      if (document.querySelector('dialog[open]:not(.gs-popup)')) return; /* nichts anderes überdecken */
      if (!force && this.cookieBannerVisible()) {
        /* erst Cookie-Entscheidung abwarten */
        if (this.timer || !this.onLeave) this.timer = window.setTimeout(() => this.open(), 10000);
        return;
      }
      this.cleanup();
      this.dialog.showModal();
    }

    close() {
      this.dialog.close();
    }

    remember() {
      store.set(KEY, String(Date.now()));
      this.cleanup();
    }

    cleanup() {
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
      if (this.timer) window.clearTimeout(this.timer);
    }

    async copyCode() {
      const code = this.querySelector('[data-gs-popup-code]');
      const out = this.querySelector('[data-gs-popup-copied]');
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code.textContent.trim());
        if (out) out.textContent = 'Kopiert.';
      } catch (e) {
        if (out) out.textContent = 'Bitte den Code markieren und kopieren.';
      }
    }
  }

  if (!customElements.get('gs-newsletter-popup')) {
    customElements.define('gs-newsletter-popup', GsNewsletterPopup);
  }
})();
